import React from 'react';
import { XLcompleted } from './Icons/XLcompleted';
import { Stack } from '@mui/material';
import { XLunfinished } from './Icons/XLunfinished';
import { WishlistIcon } from './Icons/WishlistIcon';

export const StatusInfoBox: React.FC<{ type?: string; count?: number }> = ({ type, count }) => {
  const renderInfoBox = () => {
    switch (type) {
      case 'completed':
        return (
          <Stack direction={'row'}>
            <XLcompleted width="360" height="80" />[ {count} ] Completed - For games which are 100%
            done. All extras and modes have been unlocked and finished. All significant items have
            been collected. Are you a completionist? Spent the extra time so you could say you did
            everything? Or maybe there just wasn&apos;t a whole lot to do outside of beating the
            final boss. Either way, nothing is more satisfying than a good ol&apos; 100%.
          </Stack>
        );
      case 'beaten':
        return (
          <Stack direction={'row'}>
            <XLunfinished width="350" height="80" />[ {count} ] Beaten - The main objective has been
            accomplished. Usually marked by the defeat of a final boss and/or viewing of credits.
            You&apos;ve stormed the castle, rescued the prisoners, and saved the universe from the
            clutches of an unspeakable evil. Consider yourself a hero! Some games don&apos;t have
            that obvious climax, but you can usually find some goal to reach before it is beaten.
          </Stack>
        );
      case 'unfinished':
        return (
          <Stack direction={'row'}>
            <XLunfinished width="350" height="80" />[ {count} ] Unfinished - No significant
            accomplishments. What injustice did these poor games commit to incur such neglect? No
            one knows for sure. They now spend their days sitting on shelves, silently crying out to
            be played. The most unfortunate are still encased in their shrink wrap tombs, having
            never once been nestled in the warm embrace of a game system.
          </Stack>
        );
      case 'wishlist':
        return (
          <Stack direction={'row'}>
            <WishlistIcon width="80" height="80" />
            wihslit
          </Stack>
        );
      default:
        return <></>;
    }
  };
  return renderInfoBox();
};
